module.exports = __webpack_public_path__ + "catalog.png?962b33f068f2cde207fc7dcac9406965";